module.exports = __webpack_public_path__ + "media/nao_e_nao.ae1da7ca.mp3";